<template>
  <div class="bg-static-default-hi body-1-bold p-4 text-center">
    {{ title }}
  </div>
  <RevTable :collection="yearReport" :columns>
    <template #body-amountTotal="{ item }">
      <span v-if="item.metric === 'TOTAL'" class="body-1-bold">
        <Trend :value="item.amountTotal" />
      </span>
      <template v-else>
        {{ item.amountTotal }}
      </template>
    </template>
    <template #body-amountWithoutVat="{ item }">
      <span v-if="item.metric === 'TOTAL'" class="body-1-bold">
        <Trend :value="item.amountWithoutVat" />
      </span>
      <template v-else>
        {{ item.amountWithoutVat }}
      </template>
    </template>
    <template #body-amountVat="{ item }">
      <span v-if="item.metric === 'TOTAL'" class="body-1-bold">
        <Trend :value="item.amountVat" />
      </span>
      <template v-else>
        {{ item.amountVat }}
      </template>
    </template>
  </RevTable>
</template>

<script lang="ts" setup>
import type { FinancialYearReport } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants/financial-report.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTable } from '@ds/components/Table'
import type { Column } from '@ds/components/Table/Table.constant'

import Trend from '@/components/Trend/Trend.vue'

import translations from './YearTable.translations'

defineProps<{
  yearReport: FinancialYearReport[]
  title: string
}>()

const i18n = useI18n()

const columns: Column[] = [
  {
    key: 'amountWithoutVat',
    label: i18n(translations.taxExcludedAmount),
    align: 'end' as const,
    headerClassNames: 'text-right',
  },
  {
    key: 'amountVat',
    label: i18n(translations.vat),
    align: 'end' as const,
    headerClassNames: 'text-right',
  },
  {
    key: 'amountTotal',
    label: i18n(translations.taxIncludedAmount),
    align: 'end' as const,
    headerClassNames: 'text-right',
  },
]
</script>
